import React from "react";
import { Container } from "@mui/material";
import PostManagementTable from "../PostManagementTable";

export default function AllPostsSection() {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <PostManagementTable 
        title="Todos los Posts" 
        defaultStatus="" 
      />
    </Container>
  );
}
